// Configuration for the application

// API Base URL
// In production, set VITE_API_URL in your environment variables.
// In development, it defaults to http://localhost:5000
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';
